// extracted by mini-css-extract-plugin
module.exports = {"tabsNewsBox":"tabsNewsBox-2TIB-Mrd"};